export default __webpack_public_path__ + "static/media/Frostmaw Helm.2fffc79e.jpg";